import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Link } from "@mui/material";
import React, { useState } from "react";
import SearchDropdown from "../SearchDropdown/SearchDropdown";

interface Props {
  title: string;
  value: string;
  attrName: any;
  value_update: Function;
  data: Array<any>;
  warn_status?: boolean;
  class_name?: string;
  error_message?: string;
  info_status?: boolean;
  info_message?: string;
  required?: boolean;
}

const SearchDropdownDisable: React.FC<Props> = ({
  title,
  value,
  value_update,
  attrName,
  data,
  warn_status,
  class_name,
  error_message,
  info_status,
  info_message,
  required,
}) => {
  const [disbaleToggle, setDisableToggle] = useState<boolean>(false);

  const updateMasterState = (attrName: any, value: any) => {
    console.log(";;;;;...", attrName);
    value_update(attrName, value);
  };
  return (
    <Box className="individualEdit">
      {disbaleToggle === false ? (
        <div className="staticField">
          <label>{title}</label>
          <p>{value}</p>
        </div>
      ) : (
        <SearchDropdown
          class_name={class_name}
          title={title}
          value_update={updateMasterState}
          value={value}
          attrName={attrName}
          data={data}
          warn_status={warn_status}
          error_message={""}
        />
      )}
      <Link
        className={disbaleToggle === true ? "editUpdate visible" : "editUpdate"}
        onClick={() => {
          setDisableToggle(!disbaleToggle);
        }}
      >
        {disbaleToggle === false ? <EditIcon /> : <CheckIcon />}
      </Link>
    </Box>
  );
};

export default SearchDropdownDisable;
